import { openNewWindow, facebookShareUrl } from '../../utils';
import styles from './shareInProject.module.less';
import { SecondaryButton } from '@sb1/ffe-buttons-react';
import logo from './share-on-project-modal/logos/facebook.svg';
import { Icon } from '@sb1/ffe-icons-react';
import { useDispatch } from 'react-redux';
import { webShare } from './share-utils';
import { showErrorModal } from '../../global-message/global-message-actions';
import RoundedImage from '../../components/RoundedImage';
import { MicroText } from '@sb1/ffe-core-react';

const FacebookShareButton = ({
    urlToShare,
    titleToShare,
    trackEventFunction,
    buttonClassName,
    buttonWrapperClassName,
    logoAsButton = false,
    horizontal,
    isNative,
}) => {
    const facebookUrl = facebookShareUrl(urlToShare);
    const dispatch = useDispatch();

    const onClick = async () => {
        trackEventFunction && trackEventFunction();
        if (isNative) {
            await webShare({ urlToShare, titleToShare }).catch((err) => {
                if (!err.toString().includes('AbortError')) {
                    dispatch(showErrorModal('Klarte ikke å dele.'));
                }
            });
        } else {
            openNewWindow(facebookUrl);
        }
    };

    return (
        <div className={[styles.shareComponent, horizontal ? styles.horizontal : '', buttonWrapperClassName].join(' ')}>
            <SecondaryButton
                onClick={onClick}
                className={[
                    buttonClassName || '',
                    styles.facebookShareButton,
                    logoAsButton ? styles.logoAsButton : '',
                ].join(' ')}
                alt="Del på Facebook"
                aria-label={'Del på facebook'}
                size="lg"
                iconOnly
            >
                {logoAsButton ? (
                    <RoundedImage className={styles.logo} src="fb-logo2.png" size={'48px'} />
                ) : (
                    <Icon label={'Del på Facebook'} fileUrl={logo} size="md" />
                )}
            </SecondaryButton>
            <MicroText className={styles.shareDescription}>Facebook</MicroText>
        </div>
    );
};

export default FacebookShareButton;
